// extracted by mini-css-extract-plugin
export var grid = "styles-module--grid--37S5p";
export var card = "styles-module--card--73Dy_";
export var image = "styles-module--image--2NjBB";
export var cardText = "styles-module--cardText--s7Omn";
export var cardTitle = "styles-module--cardTitle--SnUMJ";
export var cardContent = "styles-module--cardContent--GGEN-";
export var author = "styles-module--author--hdFC6";
export var cta = "styles-module--cta--2dMNa";
export var button = "styles-module--button--24vo0";